export const getDutiesOrTaxesSwitchChange = ({ field, checked, isOtherCalculationEnabled, calculateHandlingFees }) => {
  const shouldTurnOffHandlingFees = !checked && !isOtherCalculationEnabled && calculateHandlingFees

  if (shouldTurnOffHandlingFees) return { [field]: false, calculate_handling_fees: false }

  return { [field]: checked }
}
